const Api =  {
  // VirtualGroups: '/merchant/store/virtual-item-groups',
  VirtualGroups: '/api/v2/merchant/virtual-group/get',
  StoreVirtualGroups: '/api/v2/store/virtual-group/get'
}

export default (request) => {
  return {
    //  虚拟物品分组列表-查询
    getVirtualGroups: (params, options) => {
      // console.log(optiosn, )
      return request.get(options.editing ? Api.VirtualGroups : Api.StoreVirtualGroups, { params, ...options })
    }
  }
}
